import React from "react";
import dayjs from "dayjs";

interface Props {
  booking: any;
  enabled: boolean; // from useBookingRequestPage (same rule as the old page)
  hasReview: boolean;
  onOpen: () => void;
}

/** Guest-only review card. The review itself still opens your existing ReviewForm. */
const ReviewPrompt: React.FC<Props> = ({ booking: b, enabled, hasReview, onOpen }) => {
  // Same rule as isReviewEnabled: opens 15 days before check-out, never before check-in.
  const opens = (() => {
    if (!b?.check_out_date) return null;
    const out = dayjs(b.check_out_date).subtract(15, "day");
    const inn = b?.check_in_date ? dayjs(b.check_in_date) : null;
    const d = inn && inn.isAfter(out) ? inn : out;
    return d.isValid() ? d.format("MMM D, YYYY") : null;
  })();

  const title = hasReview ? "Review submitted" : "Review your stay";
  const sub = hasReview
    ? "Thank you for sharing your experience."
    : enabled
    ? "Tell future guests how it went."
    : opens
    ? `Opens ${opens}, two weeks before check-out`
    : "Opens two weeks before check-out";

  return (
    <section className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 px-5 py-5 sm:px-7">
      <div>
        <p className="text-[15px] font-semibold text-neutral-900 dark:text-white">{title}</p>
        <p className="text-[13px] text-neutral-500 dark:text-neutral-400">{sub}</p>
      </div>
      {hasReview ? (
        <span className="rounded-full bg-green-100 dark:bg-green-900/40 px-3 py-1 text-sm font-semibold text-green-800 dark:text-green-300">
          Done
        </span>
      ) : (
        <button
          type="button"
          onClick={onOpen}
          disabled={!enabled}
          className="inline-flex min-h-[48px] items-center rounded-xl bg-[#C2410C] px-5 text-sm font-semibold text-white transition-colors hover:bg-[#9A3412] disabled:cursor-not-allowed disabled:bg-neutral-200 disabled:text-neutral-500 dark:disabled:bg-neutral-800 dark:disabled:text-neutral-400"
        >
          Write review
        </button>
      )}
    </section>
  );
};

export default ReviewPrompt;
